import React from 'react';
import { Redirect } from 'react-router-dom';

import MerchantStoreForm from '../../components/merchantStores/MerchantStoreForm';
import useOrganization from '../../hooks/use-organization';

const MerchantStoreAdd = () => {
  const organizationInfo = useOrganization();

  if (!organizationInfo?.id) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <MerchantStoreForm
      mode="create"
      organizationId={organizationInfo.id}
      cancelHref="/branded-app/merchant-locations"
      successHref="/branded-app/merchant-locations"
      title="Add Merchant Location"
    />
  );
};

export default MerchantStoreAdd;
